import { createGlobalStyle } from "styled-components"
import { Theme } from "../theme"
import { markedTextStyles } from "./common/general-styles.component"
import { rawLinkStyles } from "../ui/components/link/link.component"

const GlobalStyle = createGlobalStyle`
  html {
    line-height: 1.5;
    font-size: 16px;
    -moz-font-smoothing: antialiased;
    text-rendering: geometricPrecision;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: ${({ theme }) => theme.font.basic};
  }

  p, li {
    margin: 0;
    font-weight: 300;
    line-height: 2em;
    font-size: ${14 / 16}rem;
    color: ${({ theme }: { theme: Theme }) => theme.color.text};

    @media (min-width: ${({ theme }: { theme: Theme }) =>
      theme.breakpoint.tabletHorizontal}px) {
      font-size: 1rem;
    }

    & + p {
      margin-top: 2em;
    }

    u {
      ${markedTextStyles};
    }

    a {
      ${rawLinkStyles};
    }
  }

  strong {
    font-weight: 500;
  }
`

export default GlobalStyle
